import { defineStore } from "pinia";
import { servicesList } from "../libs/options";
import { currentRangeStore } from "../composables/stores";
import { useDateStore } from "./datestore";
import axios from "axios";

export const useAppointmentStore = defineStore("appointmentStore", {
  state: () => ({
    markedStylists: {},
    jobCount: servicesList.reduce((acc, obj) => {
      acc[obj.id] = 0;
      return acc;
    }, {}),
    stylists: [],
    currentRange: currentRangeStore(),
    activeRange: {},
    duration: 0,
    firstDay: "",
    calendarView: "Day",
    events_loaded: false,
    barSearch: {
      isNotesSearch: true,
      notesEventId: null,
      isShowSearch: false,
    },
    from_dropdown: false,
  }),
  getters: {
    getStylists() {
      return this.stylists;
    },
  },
  actions: {
    addStylist(stylist) {
      this.stylists.push(stylist);
    },
    addMSFromDB(dbData) {
      const { selectedDate } = useDateStore();
      const dbstring = selectedDate
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .split(",")[0];
      if (!this.markedStylists[dbstring]) {
        this.markedStylists[dbstring] = {};
      }
      this.markedStylists[dbstring] = dbData;
    },
    addMarkedStylists(stylist) {
      const { selectedDate } = useDateStore();
      const { resource, selected } = stylist;
      const dbstring = selectedDate
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .split(",")[0];
      if (!this.markedStylists[dbstring]) {
        // If the current date does not exist, create a new array with the resource
        this.markedStylists[dbstring] = {};
      }
      // If the current date already exists, add the resource to the existing array
      let stylistData = {};
      stylistData[resource] = selected;
      this.markedStylists[dbstring] = Object.assign(
        this.markedStylists[dbstring],
        stylistData
      );

      axios
        .post(`/api/assignedstylists`, {
          date: dbstring,
          slot: resource,
          stylist: selected,
        })
        .then((response) => console.log(response));
    },
  },
});
